import FieldTrialsContainer from 'containers/workspace/FieldTrials';

const FieldTrialsPage = () => {
  return <FieldTrialsContainer />;
};

export default FieldTrialsPage;
